import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
import type { ResetStatus } from './types';

interface InfoSidebarProps {
  status: ResetStatus;
}

export const InfoSidebar: React.FC<InfoSidebarProps> = ({ status }) => {
  return (
    <div className="hidden lg:block space-y-8">
      <div className="space-y-4">
        <h1
          className="text-4xl font-bold leading-tight"
          style={{ color: 'var(--color-text-primary)' }}
        >
          {status === 'success' ? 'All done!' : 'Create a new password'}
        </h1>
        <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text-secondary)' }}>
          {status === 'success'
            ? "Your password has been updated and you're being signed in automatically."
            : 'Choose a strong password to keep your account secure.'}
        </p>
      </div>

      <div className="space-y-4">
        <div className="flex items-start gap-4">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
            style={{ backgroundColor: 'var(--color-accent-teal)' }}
          >
            <ShieldCheck className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
              Use a unique password
            </h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              Don't reuse passwords from other accounts
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
            style={{ backgroundColor: 'var(--color-accent-blue)' }}
          >
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
              Make it memorable
            </h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              Use a password manager or memorable phrase
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
